import React, { Component } from "react";
import { connect } from "react-redux";
import Footerad from "../components/UI/Footerad";
import axios from "axios";
import { CONFIG } from "../config/data";
import Headerweb from "./Headerweb";
import FooterWeb from "./Footerweb";
import Topmove from "./Topmove";
import Percentage from "./Percentage";
import Slideklinicq from "./Slideklinicq";
import AboutHeaderSlide from "./AboutHeaderSlide";
import { Helmet } from 'react-helmet';


function mapStateToProps(state) {
  return {
    appdata: state.AppData,
    userdata: state.AuthReducer.user,
    access_token: state.AuthReducer.access_token,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch({ type: "SET_LOGOUT" }),
  };
}

class AboutUs extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = React.createRef();
    const hospitaltimeout = this.state;
    this.state = {
      timeout: hospitaltimeout,
      isTimedOut: false,
      showModal: false,
      showMore: false,
      currentSlide: 0,
      description:
        "Are you facing the daily frustrations that come with managing a busy clinic? If any of these resonate, you're in the right place:",
    };
     this.slides = [
      require("../../src/assets/images/website/about img1.webp"),
      require("../../src/assets/images/website/Benifits2.webp"),
      require("../../src/assets/images/website/about img1.webp"),
    ];
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }
  handleClose() {
    this.setState({ showModal: false });
  }

  handleLogout = (e) => {
    this.setState({ showModal: false });
    e.preventDefault();
    localStorage.removeItem("token");
    this.props.logout();
  };

  _onAction(e) {
    console.log("user did something", e);

    this.setState({ isTimedOut: false });
  }

  _onActive(e) {
    console.log("user is active", e);
    this.setState({ isTimedOut: false });
  }

  _onIdle = (e) => {
    console.log("user is idle", e);
    let isTimedOut = this.state.isTimedOut;
    let timeout = this.state.timeout;
    console.log(timeout);
    console.log(isTimedOut);
    if (isTimedOut === false) {
      // console.log("the time is over");
      this.setState({ showModal: true });
      console.log(this.state.showModal);
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
    if (isTimedOut === true) {
      localStorage.removeItem("token");
      this.props.logout();
    }
  };

  handleMouseEnter = (description) => {
    this.setState({ description });
  };

  handleMouseLeave = () => {
    this.setState({
      description:
        "Are you facing the daily frustrations that come with managing a busy clinic? If any of these resonate, you're in the right place:",
    });
  };

  handleReadMore = () => {
    this.setState((prevState) => ({ showMore: !prevState.showMore }));
  };
    componentDidMount() {
    this.interval = setInterval(() => {
      this.setState((prevState) => ({
        currentSlide: (prevState.currentSlide + 1) % this.slides.length,
      }));
    }, 8000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  render() {
    const { hospitaltimeout } = this.state;
    const { showMore } = this.state;
    return (
      <div className="">
       <Helmet>
        <title>About KlinicQ | Cloud-Based Healthcare Management Software</title>
        
        <meta 
          name="description" 
          content="Learn about KlinicQ, a leading provider of cloud-based healthcare management software helping clinics and hospitals streamline operations and enhance patient care with innovative digital solutions." 
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "KlinicQ",
            "url": "https://www.klinicq.com",
            "description": "KlinicQ provides cloud-based healthcare management software solutions for clinics and hospitals.",
            "logo": "https://www.klinicq.com/logo.png"
          })}
        </script>
      </Helmet>

        <div className="">
         
          <div className="">
          
            <div className="">
              <Headerweb />
              {/* <hr className="m-0" style={{ color: "#D9F4FF" }} /> */}
<AboutHeaderSlide />
              
 

              {/* <hr className="m-0" style={{ color: "#D9F4FF" }} /> */}
              <section className="about-section">
              

            <div className="container-fluid px-0">
                 <div className="row g-0 equal-row">
                    <div className="col-lg-6 col-12">
                      <div className="image-bg-left"></div>
                    </div>
                    <div className="col-lg-6 col-12">
                      <div
                        className={`container-86  `}
                      >
                        <div className="content-box">
                          
                            <img
                              src={require("../../src/assets/images/website/Group2.webp")}
                              alt="Vision icon representing healthcare technology innovation"
                            />
                            <h4 className="mt-3" style={{ color: "#FFF" }}>
                              Vision
                            </h4>
                            <p style={{ color: "#FFF" }}>
                              Our goal is to add business value to customers in
                              information <br /> Technology{" "}
                            </p>
                            <br />
                            <img
                              src={require("../../src/assets/images/website/mission 1.webp")}
                              alt="Mission icon representing digital healthcare solutions"
                              className="mt-4"
                            />
                            <h4 className="mt-3" style={{ color: "#FFF" }}>
                              Mission
                            </h4>
                            <p style={{ color: "#FFF" }}>
                              To build customer value by delevering software
                              products and <br /> solution is innovation and
                              cost-effective ways with the highest <br />{" "}
                              standards in security ,delivery and customer
                              service for the <br /> health industry.{" "}
                            </p>
                          </div>
                          <div>
                        </div>
                      </div>
                    </div>
                  </div>     
                </div>
            
           <div className=" container-90-1 mt-5" >
                  <div className="row m-0">
                    <div className="col-lg-6 col-12 slide-left visible">
                      <div className="img-responsive1">
                        <div className="row1">
                          <div className="column1">
                            <img
                              src={require("../../src/assets/images/website/nurse.webp")}
                              className="img-item1"
                              alt="Nurse using digital healthcare management system"
                            />
                            <img
                              src={require("../../src/assets/images/website/image2.webp")}
                              className="img-item1"
                              alt="Clinic staff managing patient records using cloud based software"
                            />
                          </div>
                          <div className="column1 center1">
                            <img
                              src={require("../../src/assets/images/website/image1.webp")}
                              className="img-item1 ml-2"
                              alt="Doctor reviewing patient data in electronic clinical management system"
                            />

                            <div className="rectangle-container1">
                              <img
                                src={require("../../src/assets/images/website/Rectangle1.webp")}
                                className="img-item1 ml-2"
                                alt=""
                                aria-hidden="true"
                              />
                              <div className="text-overlay1">
                                100% Success Rate This Year
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-12 slide-right visible ">
                      <h3>
                        KlinicQ, Your Cloud-Based Solution
                        <br /> for Streamlined Clinic Management & Enhanced
                        Patient Care
                      </h3>
                     

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <p style={{ margin: "0px" }}>
                          KlinicQ application is a cloud-based Electronic
                          Clinical Management <br /> System (e CMS) that can be
                          accessed from anywhere and anytime
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <p style={{ margin: "0px" }}>
                          KlinicQ application is a comprehensive solution for
                          managing Clinic <br /> operations safely and without
                          manual error usually associated with
                          <br /> handwriting and paper-based records.
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <p style={{ margin: "0px" }}>
                          It has been developed to address operational issues
                          ,streamline the
                          <br /> process,and improve efficiency with proactive
                          engagement &<br /> Improved medication adherence.
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <p style={{ margin: "0px" }}>
                          It helps organize doctor scheduels,collate patient
                          notes,health
                          <br /> history,medical records,and other critical
                          metrics in real-time,and
                          <br /> handle payment effortlessly & improved patient
                          satisfaction.
                        </p>
                      </div>
                      <div className="find-doctor text-center py-3">
                        <button>
                          KlinicQ More
                          <img
                            src={require("../../src/assets/images/website/arrowup.webp")}
                            className="ml-2"
                            alt=""
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <Slideklinicq />

                <div class="container-90 mt-5">
  <h3 class="text-center">Experience The KlinicQ Advantage</h3>
  <p class="text-center">
    Unlock unparalleled efficiency and patient satisfaction with our comprehensive healthcare solution.
  </p>

  <div class="row8">

    <div class="rect-box">
      <img src={require("../../src/assets/images/website/Benifits4.webp")} alt="Healthcare workflow automation to boost clinic efficiency" />
      <h4 class="title8">Boost Efficiency</h4>
      <div class="content8">
        <p>Say goodbye to time-consuming administrative tasks.</p>
        <p>KlinicQ streamlines workflows, freeing up healthcare providers to focus on what matters most: patient care.</p>
      </div>
    </div>
    <div class="rect-box">
      <img src={require("../../src/assets/images/website/Benifits2.webp")} alt="Clinic management software helping increase healthcare revenue" />
      <h4 class="title8">Drive Revenue</h4>
      <div class="content8">
        <p>Happy patients are loyal patients.</p>
        <p>Increase patient retention and referrals by delivering a seamless and satisfying experience.</p>
      </div>
    </div>
    <div class="rect-box">
      <img src={require("../../src/assets/images/website/Benifits3.webp")} alt="Improved patient satisfaction through digital healthcare experience" />
      <h4 class="title8">Patient Satisfaction</h4>
      <div class="content8">
        <p>Save patients valuable time and enhance communication.</p>
        <p>KlinicQ ensures a convenient and stress-free healthcare journey.</p>
      </div>
    </div>
  </div>

  <div class="row8">
    
    <div class="rect-box">
      <img src={require("../../src/assets/images/website/Benifits1.webp")} alt="Reducing clinic operational costs with cloud based healthcare software" />
      <h4 class="title8">Minimize Expenses</h4>
      <div class="content8">
      <p>Reduce administrative costs and optimize resource allocation.</p>
      <p>KlinicQ helps you achieve significant savings, improving your bottom line.</p>
      </div>
    </div>
    <div class="rect-box">
      <img src={require("../../src/assets/images/website/Benifits6.webp")} alt="Reducing patient wait times using smart appointment scheduling" />
      <h4 class="title8">Reduce Wait Times</h4>
      <div class="content8">
        <p>Keep patients informed and engaged at every stage of their visit</p>
        <p>Our flawless integration minimizes wait times, transforming the patient experience</p>
      </div>
    </div>
    <div class="rect-box">
      <img src={require("../../src/assets/images/website/Benifits7.webp")} alt="Patient engagement tools in digital healthcare platform" />
      <h4 class="title8">Engagement</h4>
      <div class="content8">
        <p>Achieve flawless integration and <br />interactions.</p>
      </div>
    </div>
  </div>
</div>

                <div className="background-container">
                  <div className="custom-row">
                    {/* Left Column: Content */}
                    <div className="custom-col content-section">
                      <h1>Book Your Personalized Demo</h1>
                      <p>
                        Now explore how our advanced tools can revolutionize
                        Nucleo healthcare operations. Schedule a demo with our
                        team and unlock the full potential of innovation in
                        healthcare.
                      </p>
                      <a href="/contact" className="book-demo-btn">
                        Book Demo
                      </a>
                    </div>

                    {/* Right Column: Image */}
                    <div className="custom-col image-section">
                      <img
                        src={require("../../src/assets/images/website/234.webp")}
                        alt="Healthcare innovation platform demo for clinics and hospitals"
                      />
                    </div>
                  </div>
                </div>

               
              </section>

            
              <Topmove />
              <FooterWeb className="qrCodeFooter" />
            </div>
          </div>
        </div>
      </div>
    );
  }
 
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutUs);
